import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TipoRepresentacao } from '../models/tipo-representacao.model';

@Injectable({
  providedIn: 'root'
})
export class TipoRepresentacaoService {
  private readonly path = 'bolsa';

  constructor(private apiService: ApiService) {}

  // List all TipoRepresentacao
  list(): Observable<TipoRepresentacao[]> {
    return this.apiService.get<{ data: TipoRepresentacao[] }>(`${this.path}/getAllTipoRepresentacao`).pipe(
      map(response => response.data)
    );
  }

  // Get TipoRepresentacao by ID
  public show(id: string): Observable<TipoRepresentacao> {
    return this.apiService.get<{ data: TipoRepresentacao }>(`${this.path}/getTipoRepresentacaoById/${id}`).pipe(
      map(response => response.data)
    );
  }

  // Create new TipoRepresentacao
  public store(tipoRepresentacao: TipoRepresentacao): Observable<TipoRepresentacao> {
    return this.apiService
      .post<{ object: TipoRepresentacao }>(`${this.path}/AddTipoRepresentacao`, tipoRepresentacao)
      .pipe(
        map(response => response.object)
      );
  }

  // Update existing TipoRepresentacao
  public update(tipoRepresentacao: TipoRepresentacao, id: string): Observable<TipoRepresentacao> {
    return this.apiService
      .put<{ object: TipoRepresentacao }>(`${this.path}/UpdateTipoRepresentacao/${id}`, tipoRepresentacao)
      .pipe(
        map(response => response.object)
      );
  }

  // Delete existing TipoRepresentacao
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteTipoRepresentacaoById/${id}`);
  }
}
